export default __webpack_public_path__ + "static/media/frg--community-cafe.78a0ce33.png";